/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../impl/SmartsRecommenderFeature',
	'./api/VisualizationSmartsRecommenderAPI',
	'./api/DeprecatedVisualizationSmartsRecommenderAPI'
], function (APIFactory, SmartsRecommenderFeature, SmartsRecommenderAPI, DeprecatedSmartsRecommenderAPI) {
	'use strict';

	class VisualizationSmartsRecommender extends SmartsRecommenderFeature {

		constructor(options) {
			super(options);
			this.content = options.content;
			this.creationTransactionToken = options.transactionToken;
			this.visualization = options.features['Visualization'];
			this.modelsInternal = options.features['Models.internal'];
			this._api = APIFactory.createAPI(this, [SmartsRecommenderAPI]);
			this._deprecatedAPI = APIFactory.createAPI(this, [DeprecatedSmartsRecommenderAPI]);
		}

		destroy() {
			super.destroy();
			this.content = null;
			this.creationTransactionToken = null;
			this.visualization = null;
			this.modelsInternal = null;
			this._api = null;
			this._deprecatedAPI = null;
		}

		getAPI(type) {
			if (type === 'deprecated'){
				return this._deprecatedAPI;
			}

			return this._api;
		}

		getRecommendedVisualizations(){
			return super.getRecommendedVisualizations(this.visualization) ;
		}

		getRecommendedTitle() {
			return super.getRecommendedTitle(this.visualization) ;
		}

		setType(type, transactionToken){
			return super.setType(this.visualization, type, transactionToken) ;
		}

		addDataItems(dataItemSpecList, transactionToken) {
			return super.addDataItems(this.visualization, dataItemSpecList, transactionToken) ;
		}

		recommendBestVisualization(transactionToken) {
			return super.recommendBestVisualization(this.visualization, transactionToken);
		}

		// deprecated interface -- called by explore
		recommendAlternateVisualizationsAsWidgetSpecs() {
			return super.recommendAlternateVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}

		// deprecated interface -- called by explore
		recommendRelatedVisualizationsAsWidgetSpecs() {
			return super.recommendRelatedVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}

		recommendCompareVisualizationsAsWidgetSpecs() {
			return super.recommendCompareVisualizationsAsWidgetSpecs(this.visualization, JSON.parse(JSON.stringify(this.modelsInternal.getWidgetModel().toJSON())));
		}
	}

	return VisualizationSmartsRecommender;
});
